import { SiWhatsapp } from "react-icons/si";
import { WHATSAPP_URL } from "@/config/brand";

export function WhatsAppFab() {
  const whatsappUrl = WHATSAPP_URL;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 end-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20BD5A] hover:scale-110 transition-all duration-300"
      data-testid="button-whatsapp-fab"
      aria-label="Chat on WhatsApp"
    >
      <SiWhatsapp className="w-7 h-7" />
    </a>
  );
}
